import { kebabCase } from 'lodash'
import { withPrefix } from 'gatsby'
import { takeRight } from 'lodash'

const CONTENTFUL_ASSET_PATH = '/contentful/assets'
export const BLOG_PREFIX = '/blog'

export const blogLink = (slug, options = { relative: true }, isTestPath = {test: false}) => {
  const { relative } = options

  const path = `${BLOG_PREFIX}/${kebabCase(slug)}/`

  if (relative) return path

  return `${process.env.GATSBY_VNOC_WEBSITE_URL}${path}`
}
export const tagLink = (tag) => `${BLOG_PREFIX}/tags/${tag}/`

export const contentfulAssetLink = (url) => {
  const path = takeRight(url.split('/'), 3).join('/')
  return withPrefix(`${CONTENTFUL_ASSET_PATH}/${path}`)
}
